module.exports = __webpack_public_path__ + "static/img/7.2e4d50c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/7.png
// module id = V+LB
// module chunks = 0